import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayout } from '@hero/components/layouts';
import { configs } from '@hero/configs';
import {
  ChooseFeatureTypeModal,
  DashboardAnalytics,
  RecentRecognitionsExpandableTable,
  RocketModal
} from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetUser, useUpdateUser } from '@hero/services/organization-service/hooks';
import { useOnboardingStore } from '@hero/store/hooks';

import { translationMapping } from './translationMapping';

function DataDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: userData } = useGetUser();

  const [isSendGiftModalOpen, setIsSendGiftModalOpen] = useState(false);

  const { firstTour, updateFirstTour, updateTourProgress } = useOnboardingStore();
  const { mutate: mutateUpdateUser } = useUpdateUser({
    onSuccess: () => {
      updateTourProgress({
        featureType: 'recognition',
        infoCardsActive: true
      });
      updateFirstTour(true);
    }
  });

  const [showingRocketModal, setShowingRocketModal] = useState(null);

  const [firstRocketModal, secondRocketModal] = translationMapping.existingUser;

  const handleUpdateUser = () => {
    mutateUpdateUser({
      status: {
        hasWalkedThrough: {
          isCompletedFirstTour: true
        }
      }
    });
  };

  function handleCreate() {
    if (configs?.general?.simplifyFlow && !userData?.meta?.isPunchoutUser) {
      navigate(ROUTE_PATHS.SEND_GIFT_OCCASIONS);
    } else {
      setIsSendGiftModalOpen(true);
    }
  }

  return (
    <PageLayout
      header={{
        title: t('hiUser', { firstName: userData?.firstName }),
        endButton: {
          children: t('sendGifts'),
          onClick: handleCreate
        },
        showSalesNumber: false
      }}
      fullHeight
    >
      <ChooseFeatureTypeModal
        isOpen={isSendGiftModalOpen}
        onClose={() => {
          setIsSendGiftModalOpen(false);
        }}
      />

      <DashboardAnalytics />
      <RecentRecognitionsExpandableTable />
      {!firstTour && (
        <>
          {showingRocketModal === 1 && (
            <RocketModal
              title={firstRocketModal.title}
              desc={firstRocketModal.desc}
              firstButtonText="GUIDED TOUR"
              firstButtonClick={() => {
                setShowingRocketModal(2);
              }}
            />
          )}
          {showingRocketModal === 2 && (
            <RocketModal
              title={secondRocketModal.title}
              desc={secondRocketModal.desc}
              firstButtonText="START TOUR"
              firstButtonClick={handleUpdateUser}
            />
          )}
        </>
      )}
    </PageLayout>
  );
}

export { DataDashboard };
